import { useEffect } from 'react';

import type {
  EmbeddedService,
  PreChatFields,
} from '../types/salesforce-bootstrap-embedded-service';

type Init = Parameters<EmbeddedService['init']>;
type Settings = EmbeddedService['settings'];

const initEmbeddedMessaging = (
  init: Init,
  settings: Settings,
  prechat: PreChatFields,
) => {
  try {
    if (!window.embeddedservice_bootstrap) {
      return;
    }

    window.embeddedservice_bootstrap.settings.language = settings.language;

    window.addEventListener('onEmbeddedMessagingReady', () => {
      if (!window.embeddedservice_bootstrap) {
        return;
      }

      // eslint-disable-next-line no-console
      console.log('Received the onEmbeddedMessagingReady event…');
      window.embeddedservice_bootstrap.prechatAPI.setHiddenPrechatFields(
        prechat,
      );
    });

    window.embeddedservice_bootstrap.init(...init);
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error('Error loading Embedded Messaging: ', err);
  }
};

export const useSalesforceMessaging = (
  src: string,
  init: Init,
  settings: Settings,
  prechat: PreChatFields,
) =>
  useEffect(() => {
    if (window.embeddedservice_bootstrap) {
      initEmbeddedMessaging(init, settings, prechat);
    } else {
      const script = document.createElement('script');
      script.onload = () => initEmbeddedMessaging(init, settings, prechat);
      script.setAttribute('src', src);
      document.body.appendChild(script);
    }
  }, []);
